import { render, staticRenderFns } from "./MyInvoice.vue?vue&type=template&id=023a3922&scoped=true&"
import script from "./MyInvoice.vue?vue&type=script&lang=js&"
export * from "./MyInvoice.vue?vue&type=script&lang=js&"
import style0 from "./MyInvoice.vue?vue&type=style&index=0&id=023a3922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a3922",
  null
  
)

export default component.exports